module.exports = __webpack_public_path__ + "img/tutorial_simulated_02.d7dbbed7.gif";